import ShortcutKeys from './ShortcutKeys';

export default ShortcutKeys;
